import React from 'react'
import { Box, ListItem, ListItemText, Typography, Divider, List, IconButton } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import { REQUISITION_FORM } from '../../constant/permission'

export const DocumentCard = (props) => {
  const { permission } = props

  const quicklinks = [
    {
      itemText: 'Staff Handbook',
      path: '/documents/HTGroupStaffHandbook2018.pdf',
      download: 'HTGroupStaffHandbook2018.pdf',
      hasAccess: true,
    },
    {
      itemText: 'Public Holidays',
      path: '/documents/public_holiday.pdf',
      download: 'public_holiday.pdf',
      hasAccess: true,
    },
    {
      itemText: 'Intercom List',
      path: '/documents/intercom_list.pdf',
      download: 'intercom_list.pdf',
      hasAccess: true,
    },
    {
      itemText: 'Manpower Requisition Form',
      path: '/documents/requisition_form.pdf',
      download: 'requisition_form.pdf',
      hasAccess: permission.includes(REQUISITION_FORM),
    },
  ]

  return (
    <Box bgcolor='#fff' borderRadius={3} display='flex' width='100%' height='100%'>
      <Box display='flex' width='100%' flexDirection='column' p={5}>
        <Typography variant='h6'>Documents</Typography>
        <Divider />
        <List>
          {quicklinks
            .filter((link) => link.hasAccess)
            .map((link) => (
              <ListItem key={link.itemText}>
                <ListItemText>{link.itemText}</ListItemText>
                <IconButton
                  color='primary'
                  href={link.path}
                  download={link.download}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <DownloadIcon style={{ color: '#999999' }} />
                </IconButton>
              </ListItem>
            ))}
        </List>
      </Box>
    </Box>
  )
}
